export default {
      id: "statements-emailed-usage",
      viewBox: "0 0 56 56",
      url: __webpack_public_path__ + "svg-sprite-defs.svg#statements-emailed",
      toString: function () {
        return this.url;
      }
    }